// common configuration
var config = {
	api: {
		endpoints: {
			token: "rpc/platform_jwt_token_generate",
			shifts: "asw_order_shift_person_current",
			person: "person",
			daysWorked: "rpc/wa_person_get_days_worked",
			photo: "rpc/asw_person_get_photo",
			email: "rpc/asw_contact_form_send_email",
			hoursPaid: "rpc/wa_order_shift_calculate_shift_hour_break",
			forgottenPassword: "rpc/asw_send_change_password_link",
			shiftButtons: "wa_order_dep_shift_cycle",
			resetPassword: "rpc/asw_change_password_by_jwt_token"
		},
		tokenExpiration: 4*3600*1000 // 4 hours
	},
	afterLoginRoute: '/list',
	error: {
		prefix: {
			recordNotExists: "RECORD_NOT_EXISTS",
			recordWasChanged: "RECORD_WAS_CHANGED",
			wrongLogin: "WRONG_USER_OR_PASSWORD",
			noOpenPeriod: "NO_OPEN_PERIOD"
		}
	}
}

if (__CUSTOMER__ == "ha") {
	Object.assign(config, {
		baseUrl: "https://api.blahovec.cz/",
		tokenDomain: "humanagency.cz",
		resetPasswordToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoid2ViYmljcyIsImRvbWFpbiI6Imh1bWFuYWdlbmN5LmN6IiwiZXhwIjoyMDAwMDAwMDAwfQ.CQXYGSFW2SPMB6kI_Guox23x8MzA5q9JYc0r5I0jBAw"
	});
}

if (__CUSTOMER__ == "sks") {
	Object.assign(config, {
		baseUrl: "http://b.blahovec.cz:3002",
		tokenDomain: "sksbu.cz",
		resetPasswordToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiZWtyX3dzIiwiZG9tYWluIjoiZW1vbmFrcm9uaS5jeiIsImV4cCI6MjAwMDAwMDAwMH0.TyZ_HcfU2uKU9nEqV6D1JzE2e88kU6ePsxEUVJ_1i4s"
	});
}

if (process.env.NODE_ENV == "production" && __CUSTOMER__ == "ha") {
	Object.assign(config, {
		baseUrl: "https://api.blahovec.cz/",
		resetPasswordToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoid2ViYmljcyIsImRvbWFpbiI6Imh1bWFuYWdlbmN5LmN6IiwiZXhwIjoyMDAwMDAwMDAwfQ.CQXYGSFW2SPMB6kI_Guox23x8MzA5q9JYc0r5I0jBAw"
	});
}

if (process.env.NODE_ENV == "production" && __CUSTOMER__ == "sks") {
	Object.assign(config, {
		baseUrl: "https://api.alpha.blahovec.cz",
		resetPasswordToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiZWtyX3dzIiwiZG9tYWluIjoiZW1vbmFrcm9uaS5jeiIsImV4cCI6MjAwMDAwMDAwMH0.TyZ_HcfU2uKU9nEqV6D1JzE2e88kU6ePsxEUVJ_1i4s"
	});
}


export const CONFIG = config;